import React, { Component } from "react";

import "./AthProduct.css";

class AthProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const upc =
      this.props.product && this.props.product.smartId
        ? "0" + this.props.product.smartId.toString()
        : "0";
    return (
      <div className="ath-product">
        {window.location.pathname.includes("/hair/") ? (
          <a
            onClick={e => {
              let availableForShoppable =
                this.props.product &&
                (this.props.product.upcNumber || this.props.product.smartId);
              if (availableForShoppable) e.preventDefault();
              this.props.handleProductClick(
                upc,
                this.props.product.title,
                "1.00",
                this.props.product.brand,
                1,
                this.props.product.routine,
                availableForShoppable
              );
            }}
            target="_blank"
            href={this.props.product.link}
          >
            <img
              className="ath-recommendations__category-product-image"
              alt={this.props.product.brand + " " + this.props.product.title}
              src={this.props.product.image}
            />
          </a>
        ) : (
          <img
            className="ath-recommendations__category-product-image"
            
            alt={this.props.product.brand + " " + this.props.product.title}
            src={this.props.product.image}
          />
        )}
        <div className="ath-recommendations__category-product-info">
          {window.location.pathname.includes("/hair/") &&
          this.props.product.premium ? (
            <div className="hair-recommendations__premium-tag">
              <img src="/images/hair/recommendations/premium.svg" />
            </div>
          ) : null
          //  ( TiSortNumericallyOutline)
          
          }
          <h4 className="ath-recommendations__category-product-brand">
            {this.props.product.brand}
          </h4>
          <div className="ath-recommendations__category-product-name">
            {this.props.product.title.includes(this.props.product.brand)
              ? this.props.product.title.replace(this.props.product.brand, "")
              : this.props.product.title}
          </div>
        </div>
        <div className="ath-recommendations__category-product-button-container">
          {window.location.pathname.includes("/hair/") ? (
            <a
              onClick={e => {
                let availableForShoppable =
                  this.props.product &&
                  (this.props.product.upcNumber || this.props.product.smartId);
                if (availableForShoppable) e.preventDefault();
                this.props.handleProductClick(
                  upc,
                  this.props.product.title,
                  "1.00",
                  this.props.product.brand,
                  1,
                  this.props.product.routine,
                  availableForShoppable
                );
              }}
              target="_blank"
              href={this.props.product.link}
            >
              <button className="ath-recommendations__category-product-button">
                Buy Now
              </button>
            </a>
          ) : this.props.product && this.props.product.smartId ? (
             <div class="ps-widget" ps-sku={this.props.product.upcNumber}></div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default AthProduct;



// WEBPACK FOOTER //
// ./src/ath/components/recommendations/AthProduct.js